import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, TransitionGroup as _TransitionGroup, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "toasts-list" };
import { transitionHook } from "../utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Toasts',
    props: {
        teleport: { type: [String, Object], default: () => document.body },
    },
    setup(__props) {
        const leave = transitionHook((el) => {
            el.style.setProperty('margin-top', `calc(-${el.scrollHeight}px - var(--gap-sm))`);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: __props.teleport }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_TransitionGroup, {
                        name: "toast",
                        onLeave: _unref(leave)
                    }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["onLeave"])
                ])
            ], 8 /* PROPS */, ["to"]));
        };
    }
});
